import ActionsMenu from "components/Editorial/ActionsMenu/Loader";
import React from "react";
import ReactDOM from "react-dom";

export const EDITORIAL_MENU_SELECTOR = ".editorial-menu-container";

export default function renderEditorialActionsMenu(actionsPath) {
  const editorialMenuEl = document.querySelector(EDITORIAL_MENU_SELECTOR);
  if (editorialMenuEl !== null) {
    const editorialMenuComponent = React.createElement(ActionsMenu, { actionsPath });
    ReactDOM.render(editorialMenuComponent, editorialMenuEl);
  }
}
